import { render, staticRenderFns } from "./UserPicker.vue?vue&type=template&id=57bc0cd5&scoped=true"
import script from "./UserPicker.vue?vue&type=script&lang=ts"
export * from "./UserPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bc0cd5",
  null
  
)

export default component.exports